import {
  CorrectionReasonOptions,
  FrdDeterminationProcedureOptions,
  FrdEvaluationProcedureOptions,
  GEMMeasurement,
  QualityRegimeOptions,
  correctionReasonOptions,
  frdDeterminationProcedureOptions,
  frdEvaluationProcedureOptions,
  qualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

const FRD_FIELD_SCHEMA_LIBRARY = {
  // Shared metadata fields
  projectNumber: addSchema<string>({ type: "string", title: "Projectnummer" }),
  broId: addSchema<string>({ type: "string", title: "BRO-ID Formatieweerstand dossier" }),
  qualityRegime: addSchema<QualityRegimeOptions>({
    type: "string",
    title: "Kwaliteitsregime",
    enum: qualityRegimeOptions.map((opt) => opt.value),
  }),
  deliveryAccountableParty: addSchema<string>({
    type: "string",
    title: "Bronhouder [KVK]",
  }),
  correctionReason: addSchema<CorrectionReasonOptions>({
    type: "string",
    title: "Correctie reden",
    enum: correctionReasonOptions.map((opt) => opt.value),
  }),

  // FRD Start Registration fields
  objectIdAccountableParty: addSchema<string>({ type: "string", title: "Interne naam" }),
  gmwBroId: addSchema<string>({ type: "string", title: "BRO-ID Put" }),
  tubeNumber: addSchema<string>({ type: "string", title: "Buisnummer" }),
  groundwaterMonitoringNets: addSchema<string[]>({
    type: "array",
    title: "Grondwatermeetnetten",
    items: { type: "string" },
  }),

  // FRD Measurement fields
  measurementDate: addSchema<string>({ type: "string", format: "date", title: "Datum meting" }),
  measurementOperatorKvk: addSchema<string>({
    type: "string",
    title: "Uitvoerder meting [KVK]",
  }),
  determinationProcedure: addSchema<FrdDeterminationProcedureOptions>({
    type: "string",
    title: "Bepalingsprocedure",
    enum: frdDeterminationProcedureOptions.map((opt) => opt.value),
  }),
  evaluationProcedure: addSchema<FrdEvaluationProcedureOptions>({
    type: "string",
    title: "Beoordelingsprocedure",
    enum: frdEvaluationProcedureOptions.map((opt) => opt.value),
  }),

  // File fields
  measurementFile: addSchema<Blob>({
    type: "string",
    format: "data-url",
    title: "Metingen bestand (CSV/Excel)",
  }),
  measurementConfigFile: addSchema<Blob>({
    type: "string",
    format: "data-url",
    title: "Meetconfiguraties bestand (CSV/Excel)",
  }),

  measurements: addSchema<GEMMeasurement[]>({
    type: "array",
    items: {
      type: "object",
      properties: {
        value: { type: "number" },
        unit: { type: "string" },
        configuration: { type: "string" },
      },
      required: [],
    },
  }),
};

type FrdFieldSchemaLibraryType = typeof FRD_FIELD_SCHEMA_LIBRARY;

export function pickFrdLibraryFields<K extends keyof FrdFieldSchemaLibraryType>(
  fieldNames: readonly K[]
): Pick<FrdFieldSchemaLibraryType, K> {
  const result = {} as Pick<FrdFieldSchemaLibraryType, K>;
  for (const name of fieldNames) {
    result[name] = FRD_FIELD_SCHEMA_LIBRARY[name];
  }
  return result;
}
